import { MultiFactorResolver, User } from '@firebase/auth'
import { createContext, useContext, useState } from 'react'
import { FirebaseAuth } from 'shared/services'
import { LoadingStatus } from 'shared/types'

export interface MultiFactorChallenge {
  resolver: MultiFactorResolver
  email?: string
  onResolved: () => Promise<void> | void
}

export interface AuthContextValue {
  user: User | null
  auth: FirebaseAuth | null
  loading: LoadingStatus
  error?: string | null
  setError?: (err: string | null) => void
  multiFactorChallenge?: MultiFactorChallenge | null
  setMultiFactorChallenge?: (challenge: MultiFactorChallenge | null) => void
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  auth: null,
  loading: LoadingStatus.Idle,
  error: null,
  multiFactorChallenge: null,
})

export const AuthProvider = ({ children, value }: any) => {
  const [error, setError] = useState<string | null>(null)
  const [multiFactorChallenge, setMultiFactorChallenge] =
    useState<MultiFactorChallenge | null>(null)
  return (
    <AuthContext.Provider
      value={{
        ...value,
        error,
        setError,
        multiFactorChallenge,
        setMultiFactorChallenge,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuthContext = () => useContext(AuthContext)
